import axios from "axios";
import { API, DJANGO_SECRET_ID, DJANGO_CLIENT_ID } from "../../../BackendConnections";
import axiosInstance from "../../../components/authentication/helper/axiosApi";
import { ActionTypes } from "../../constants/action-types";

export const signInAction = (data, navigate) => {
    return async (dispatch) => {
        try {
            await axios.post(`${API}/api/auth/token/`, data).then((response) => {
                localStorage.setItem("access_token", response.data.access_token);
                localStorage.setItem("refresh_token", response.data.refresh_token);
                axiosInstance.defaults.headers["Authorization"] =
                    "Bearer " + localStorage.getItem("access_token");

                dispatch({
                    type: ActionTypes.SIGNIN_SUCCESS,
                    payload: response.data,
                });

                navigate("/user/dashboard");
            });
        } catch (error) {
            dispatch({
                type: ActionTypes.SIGNIN_FAIL,
                payload: error.response.data,
            });
        }
    };
};


export const socialLoginAction = (code, navigate) => {
    return async (dispatch) => {
        try {

            const formData = new FormData();

            formData.append("AuthorizationCode", code);

            axios.post(`${API}/api/user/linkedin_access/`, formData)
                .then((response) => {
                    const data = JSON.parse(response.data);
                    axios.post(`${API}/api/auth/convert-token`, {
                        token: data["access_token"],
                        backend: "linkedin-oauth2",
                        grant_type: "convert_token",
                        client_id: DJANGO_CLIENT_ID,
                        client_secret: DJANGO_SECRET_ID,
                    })
                        .then((res) => {
                            localStorage.setItem("access_token", res.data.access_token);
                            localStorage.setItem("refresh_token", res.data.refresh_token);
                            axiosInstance.defaults.headers["Authorization"] =
                                "Bearer " + localStorage.getItem("access_token");

                            dispatch({
                                type: ActionTypes.SIGNIN_SUCCESS,
                                payload: response.data,
                            });


                            navigate("/user/dashboard");
                        });
                });


        } catch (error) {

        }
    }
};


export const signOutAction = (navigate) => {
    return async (dispatch) => {
        try {
            const response = await axios.post(`${API}/api/auth/revoke-token`, {
                client_id: DJANGO_CLIENT_ID,
                client_secret: DJANGO_SECRET_ID,
                token: localStorage.getItem("access_token"),
            });

            dispatch({
                type: ActionTypes.RESET_STORE,
                payload: response,
            });

            localStorage.removeItem("access_token");
            localStorage.removeItem("refresh_token");

            navigate("/signin");
        } catch (error) {
            dispatch({
                type: ActionTypes.SIGN_OUT,
                payload: error.response.data,
            });
        }
    };
};

export const signUpAction = (data, navigate) => {
    return async (dispatch) => {
        try {

            const response = await axios.post(`${API}/api/user/register/`, data);

            navigate("/signin", { state: response.data });

        } catch (error) {

            dispatch({
                type: ActionTypes.SIGNUP_FAIL,
                payload: error.response.data,
            });

        }
    };
};

export const forgetPasswordAction = (data, navigate) => {
    return async (dispatch) => {
        try {
            const response = await axios.post(`${API}/api/user/forgetPassword/`, data);
            dispatch({
                type: ActionTypes.FORGET_PASSWORD,
                payload: response.data,
            });
            navigate('/signin', { state: response.data });
        } catch (error) {
            dispatch({
                type: ActionTypes.FORGET_PASSWORD,
                payload: error.response.data,
            });
        }
    }
};

export const emailActivationAction = (data, navigate) => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.post(`/api/user/regenerateEmailVerification/`, data);
            dispatch({
                type: ActionTypes.EMAIL_ACTIVATION,
                payload: response.data,
            });
            navigate('/signin', { state: response.data });
        } catch (error) {
            dispatch({
                type: ActionTypes.EMAIL_ACTIVATION,
                payload: error.response.data,
            });
        }
    }
};

export const resetPasswordAction = (uid, id, data, navigate) => {
    return async (dispatch) => {
        try {
            const response = await axios.post(`${API}/api/user/resetPassword/${uid}/${id}`, data);

            dispatch({
                type: ActionTypes.RESET_PASSWORD,
                payload: response.data,
            });

            navigate('/signin', { state: response.data });
        } catch (error) {

            dispatch({
                type: ActionTypes.RESET_PASSWORD,
                payload: error.response.data,
            });
        }
    }
};
